import React from 'react';
import PropTypes from 'prop-types';

import Modal from 'components/Modal';
import ModalHeader from 'components/ModalHeader';
import DatePicker from 'components/DatePicker';

import GMap from './GMap';
import './styles.scss';

const PickUpModal = ({
  isOpen,
  controlledDate, handleChange, reference, pickUpDate, onFocusInput, setDateManualyHand,
  prevDisabled, backHandl, saveDeliveryHandl, position
}) => (
  <Modal isOpen={isOpen}>
    <div className="pick-up-modal">
      <ModalHeader backHandl={backHandl}>
        When pick up a car?
      </ModalHeader>
      <div className="modal-top">
        <div className="top-location">
          <i className="material-icons">&#xE0C8;</i>
        </div>
        <p className="top-title">
            27 Roytec Road, Unit 9 Woodbridge, ON L4L 8E3
        </p>
      </div>
      <div className="modal-map">
        <GMap
          googleMapURL="https://maps.googleapis.com/maps/api/js?v=3.exp&key=AIzaSyCRN2DYEwpJpX7d1oMDNiSY_YzDe0nFM9I&libraries=geometry,drawing,places"
          loadingElement={<div style={{ height: '100%' }} />}
          containerElement={<div style={{ height: 'auto', position: 'relative' }} />}
          mapElement={<div style={{ height: '0', paddingBottom: '60%' }} />}
          position={position}
        />
      </div>
      <DatePicker
        controlledDate={controlledDate}
        handleChange={handleChange}
        reference={reference}
        pickUpDate={pickUpDate}
        onFocusInput={onFocusInput}
        setDateManualyHand={setDateManualyHand}
        prevDisabled={prevDisabled}
      />
      <div className="modal-hours">
        <button className="modal-hour" onClick={saveDeliveryHandl(position, '27 Roytec Road, Unit 9 Woodbridge, ON L4L 8E3', '2:00 PM')} >
            2:00 PM
        </button>
        <button className="modal-hour" onClick={saveDeliveryHandl(position, '27 Roytec Road, Unit 9 Woodbridge, ON L4L 8E3', ' 4:00 PM')} >
            4:00 PM
        </button>
        <button className="modal-hour" onClick={saveDeliveryHandl(position, '27 Roytec Road, Unit 9 Woodbridge, ON L4L 8E3', '6:00 PM')} >
           6:00 PM
        </button>
      </div>
      {/* <button className="modal-show">
        Show more
      </button> */}
    </div>
  </Modal>
);

PickUpModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  controlledDate: PropTypes.instanceOf(Date).isRequired,
  handleChange: PropTypes.func.isRequired,
  reference: PropTypes.func.isRequired,
  pickUpDate: PropTypes.string.isRequired,
  onFocusInput: PropTypes.func.isRequired,
  prevDisabled: PropTypes.bool.isRequired,
  setDateManualyHand: PropTypes.func.isRequired,
  saveDeliveryHandl: PropTypes.func.isRequired,
  backHandl: PropTypes.func.isRequired,
  position: PropTypes.shape({
    lat: PropTypes.number.isRequired,
    lng: PropTypes.number.isRequired
  }).isRequired
};

export default PickUpModal;



// WEBPACK FOOTER //
// ./src/pages/Delivery/components/PickUpModal/index.js